import React from 'react';
import { TaskState } from 'gql/graphql';
import { Tooltip } from 'react-tooltip';
import fileIcon from 'assets/images/file.svg';

const tooltipsTexts: any = {
  "APPROVED": 'Approved',
  "REVIEW": 'In Review',
  "REQUEST_ERROR": 'Rejected',
  "DRAFT": 'Not submmitted',
  "INCOMPLETE": 'Incomplete'
}

const tooltipTexts = (state: string) => state? tooltipsTexts[state]: 'Not submmitted';

interface Props {
  tagKey: string;
  textTwo?: string;
  state: TaskState | string;
  isIconState?: boolean;
}

const CircleTag = ({
  tagKey,
  state,
  textTwo,
  isIconState = false
}: Props) => {
  state = state.toUpperCase();

  return (
    <div className={`circle-tag circle-tag-${state}`}>
      <div
        data-tooltip-id={`circle-state-${tagKey}`}
        data-tooltip-html={`<b>${tooltipTexts(state)}</b> ${textTwo? `<br/><span>${textTwo}</span>`: ''}`}
        className={`circle circle-${state}`}
      >
        {isIconState && (
          <img
            src={fileIcon}
            alt="Draft file icon"
            className={`circle-tag-icon circle-tag-icon-${state}`}
            style={{ width: 12, height: 12 }}
          />
        )}
      </div>
      <Tooltip
        id={`circle-state-${tagKey}`}
        className={`circle-state-tooltip circle-state-tooltip-${state}`}
      />
    </div>
  );
};

export default CircleTag;
